import React from 'react';

const SimilarProducts = () => {
    return (
        <div>
            <h1 >Discover similar items</h1>
        </div>
    );
};

export default SimilarProducts;